/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
   
  var accordion_click = document.querySelector(".product__block.product__accordions .product__accordion button")
  if (accordion_click) {
    setTimeout(function() { 
      accordion_click.click();
    },1000);  
  }

  // mobile filter css

  var blog_title = document.querySelector('.blog__tags-title');
  if (blog_title) {
    document.querySelector('.blog__tags-title').addEventListener('click', (elm)=>{
      document.querySelector('.blog__tags').classList.toggle('active');
    });
  }
  
  // mobile menu js
  
  document.querySelectorAll('.mobile-nav-button').forEach((elm)=>{
    elm.addEventListener('click', (el)=>{
      document.querySelectorAll('.mobile-nav-submenu').forEach((e)=>{
        e.classList.remove('active')
      });
      document.querySelector('.mobile-nav-list').classList.add('child-open')
      el.currentTarget.nextElementSibling.classList.add('active');
    });
  })

  document.querySelectorAll('.prev-nav-header').forEach((elm)=>{
    elm.addEventListener('click', (el)=>{
      document.querySelectorAll('.mobile-nav-submenu').forEach((e)=>{
        e.classList.remove('active')
      });
      document.querySelector('.mobile-nav-list').classList.remove('child-open')
    });
  }); 

  // grand child menu toggle class

  document.querySelectorAll('.mobile-submenu-link-btn').forEach((elm)=>{
      
    elm.addEventListener('click', (el)=>{
      console.log('el', el)
      if( el.currentTarget.closest('.mobile-submenu-item').classList.contains("submenu-close") ){
        el.currentTarget.closest('.mobile-submenu-item').classList.remove('submenu-close');
      }
      else {
        // document.querySelectorAll('.mobile-submenu-item').forEach((e)=>{
        //   e.classList.remove('submenu-close')
        // });
        el.currentTarget.closest('.mobile-submenu-item').classList.add('submenu-close');
      } 
      
      
    });
  });

  // toggle menu event (overlay sits above theme drawer button on touch devices)
  var mmToggle = document.querySelector('.mm-menu-toggle');
  var mobileDrawer = document.querySelector('.mobile-nav-drawer');
  if (mmToggle && mobileDrawer) {
    mmToggle.addEventListener('click', function (e) {
      mmToggle.classList.toggle('open');
      document.body.classList.toggle('menu-body-open');
      mobileDrawer.classList.toggle('menu-open');
    });
  }

  /**
   * Homepage "New Featured collection" uses Slick (not theme Flickity).
   * Init runs from deferred custom.js so DOM exists; AOS is refreshed after
   * Slick mutates the DOM (otherwise product tiles can stay opacity:0 on mobile).
   */
  function initFeaturedCollectionSlick(root) {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) return;

    var $sliders = root ? $(root).find('.featured__collection--slider') : $('.featured__collection--slider');
    $sliders.each(function () {
      var $slider = $(this);
      if ($slider.hasClass('slick-initialized')) return;
      if (!$slider.children('.product-grid-item, [data-promo]').length) return;

      var $prev = $slider.siblings('.featured-collection-arrow').find('.slick-prev');
      var $next = $slider.siblings('.featured-collection-arrow').find('.slick-next');
      if (!$prev.length || !$next.length) return;

      $slider.on('init', function () {
        if (typeof AOS !== 'undefined' && typeof AOS.refresh === 'function') {
          AOS.refresh();
        }
      });

      try {
        $slider.slick({
          rows: 1,
          dots: false,
          prevArrow: $prev,
          nextArrow: $next,
          infinite: true,
          speed: 300,
          slidesToShow: 4,
          slidesToScroll: 2,
          responsive: [
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                rows: 1
              }
            }
          ]
        });
      } catch (err) {
        console.warn('Featured collection Slick init failed', err);
      }
    });

    if (typeof AOS !== 'undefined' && typeof AOS.refresh === 'function') {
      AOS.refresh();
    }
  }

  function runFeaturedCollectionSlickInit() {
    initFeaturedCollectionSlick(null);
  }

  // Run after theme.defer.js registers its DOMContentLoaded handler so sections + AOS init first
  document.addEventListener('DOMContentLoaded', runFeaturedCollectionSlickInit);

  // Move focus to form status messages on page load so screen readers announce them.
  // setTimeout 0 lets theme.js finish its own DOMContentLoaded work (e.g. revealing
  // the recover-password success text) before we query visibility.
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
      var candidates = document.querySelectorAll('[role="alert"][tabindex="-1"], [role="status"][tabindex="-1"]');
      for (var i = 0; i < candidates.length; i++) {
        if (getComputedStyle(candidates[i]).display !== 'none') {
          candidates[i].focus({ preventScroll: false });
          break;
        }
      }
    }, 0);
  });

  window.addEventListener('load', function () {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) return;
    $('.featured__collection--slider.slick-initialized').each(function () {
      $(this).slick('setPosition');
    });
    if (typeof AOS !== 'undefined' && typeof AOS.refresh === 'function') {
      AOS.refresh();
    }
  });

  document.addEventListener('shopify:section:load', function (e) {
    var tgt = e.target;
    if (!tgt || typeof tgt.querySelector !== 'function') return;
    if (!tgt.querySelector('.featured__collection--slider')) return;
    window.setTimeout(function () {
      initFeaturedCollectionSlick(tgt);
      var $ = window.jQuery;
      if ($ && $.fn && $.fn.slick) {
        $(tgt).find('.featured__collection--slider.slick-initialized').slick('setPosition');
      }
      if (typeof AOS !== 'undefined' && typeof AOS.refresh === 'function') {
        AOS.refresh();
      }
    }, 0);
  });


  // Skio /a/account login — WCAG fix for dynamically injected error messages.
  // Skio's React app inserts a plain <p class="text-red-500"> when login fails,
  // with no live region or aria-invalid, so screen readers never hear the error.
  // We watch for that <p> and mirror its text into a visually-hidden role="alert"
  // we create, and set aria-invalid on the email input.
  (function () {
    if (!window.location.pathname.startsWith('/a/account')) return;

    var LIVE_REGION_ID = 'skio-error-live-region';
    var ERROR_P_ID = 'skio-email-error';

    var liveRegion = document.createElement('div');
    liveRegion.id = LIVE_REGION_ID;
    liveRegion.setAttribute('role', 'alert');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0';
    document.body.appendChild(liveRegion);

    // `announced` tracks whether the current visible error has already been read out.
    // Reset to false whenever the error disappears or the user re-submits so the
    // next applyErrorState call re-announces even if the text hasn't changed.
    var announced = false;
    var pendingAnnounce = null;
    var submitTimeout = null;

    function applyErrorState() {
      var inputWrapper = document.querySelector('[data-skio-name="login-email-input"]');
      if (!inputWrapper) return;
      var formContainer = inputWrapper.parentElement;
      if (!formContainer) return;
      var input = inputWrapper.querySelector('input[name="email"]');
      var errorP = formContainer.querySelector('p.text-red-500');

      if (errorP) {
        if (!announced) {
          announced = true;
          var text = errorP.textContent.trim();
          if (!errorP.id) errorP.id = ERROR_P_ID;
          // Focus the error paragraph — most reliable announcement method across
          // all AT/browser combos, including VoiceOver+Chrome which ignores live regions.
          errorP.setAttribute('tabindex', '-1');
          if (pendingAnnounce) clearTimeout(pendingAnnounce);
          pendingAnnounce = setTimeout(function () {
            errorP.focus({ preventScroll: true });
            // Also update the live region for AT combinations that prefer it.
            liveRegion.textContent = '';
            setTimeout(function () { liveRegion.textContent = text; }, 50);
          }, 100);
        }
        if (input) {
          input.setAttribute('aria-invalid', 'true');
          var existing = input.getAttribute('aria-describedby') || '';
          if (existing.indexOf(ERROR_P_ID) === -1) {
            input.setAttribute('aria-describedby', (existing + ' ' + ERROR_P_ID).trim());
          }
        }
      } else {
        announced = false;
        if (pendingAnnounce) { clearTimeout(pendingAnnounce); pendingAnnounce = null; }
        liveRegion.textContent = '';
        if (errorP) errorP.removeAttribute('tabindex');
        if (input) {
          input.removeAttribute('aria-invalid');
          var current = input.getAttribute('aria-describedby') || '';
          var cleaned = current.replace(ERROR_P_ID, '').replace(/\s+/g, ' ').trim();
          if (cleaned) {
            input.setAttribute('aria-describedby', cleaned);
          } else {
            input.removeAttribute('aria-describedby');
          }
        }
      }
    }

    function onSubmission() {
      announced = false;
      if (pendingAnnounce) { clearTimeout(pendingAnnounce); pendingAnnounce = null; }
      liveRegion.textContent = '';
      if (submitTimeout) clearTimeout(submitTimeout);
      submitTimeout = setTimeout(applyErrorState, 3000);
    }

    // Capture phase fires before React synthetic events and before any stopPropagation.
    // Walk tagName manually rather than using closest() for broadest compatibility.
    document.addEventListener('click', function (e) {
      var t = e.target;
      while (t && t.tagName) {
        if (t.tagName === 'BUTTON') {
          var p = t.parentElement;
          while (p && p.tagName) {
            if (p.tagName === 'MAIN') { onSubmission(); break; }
            p = p.parentElement;
          }
          break;
        }
        t = t.parentElement;
      }
    }, true);

    // MutationObserver on body. Filter out mutations caused by our own liveRegion
    // text changes so we don't re-trigger applyErrorState from our own writes.
    var observer = new MutationObserver(function (mutations) {
      var external = mutations.some(function (m) {
        var node = m.target;
        while (node) {
          if (node === liveRegion) return false;
          node = node.parentNode;
        }
        return true;
      });
      if (external) applyErrorState();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }());

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

  

  window.cartcount = function() {
    if(typeof window.Rebuy.SmartCart !== "undefined"){
      var item_count = window.Rebuy.SmartCart.itemCount();
      var cart_title = document.querySelector('.rebuy-cart__flyout-header h2');
      var tag = document.createElement("span");
      tag.classList.add('count');
      var text = document.createTextNode(item_count);
      tag.appendChild(text);
      if(item_count > 0){
        document.querySelectorAll('.menu__item.menu__item--icons .cart_counter').forEach((c_item)=>{
          c_item.classList.remove('count-zero')
        });
        if( document.querySelectorAll('.rebuy-cart__flyout-header .count').length > 0 ){
          document.querySelector('.rebuy-cart__flyout-header .count').innerHTML = item_count;
        }else if(cart_title) {
          cart_title.appendChild(tag);
        }
      }else {
        document.querySelectorAll('.menu__item.menu__item--icons .cart_counter').forEach((c_item)=>{
          c_item.classList.add('count-zero')
        });
        if( document.querySelectorAll('.rebuy-cart__flyout-header .count').length > 0 ){
          document.querySelector('.rebuy-cart__flyout-header .count').innerHTML = '';
        }
      }
      document.querySelector('.menu__item.menu__item--icons .cart_counter').innerHTML = item_count;
      
    }
  }

  document.addEventListener('rebuy:smartcart.init', (event) => {
    //window.cartcount()
  });
  document.addEventListener('rebuy:smartcart.ready', (event) => {
		window.cartcount();
  });

  document.addEventListener('rebuy:smartcart.show', (event) => {
      window.cartcount();
      var rebuyCheckout = document.querySelector('.rebuy-cart__checkout-button');
      // how to access a free shipping tier in the Progress Bar
      
      
      // how to access the free shipping minimum
      if (Rebuy.SmartCart.progressBar != null){
        const freeShippingTier = Rebuy.SmartCart.progressBar.tiers.find(tier => tier.type === 'shipping');
        var cartPrice = window.Rebuy.Cart.cart.items_subtotal_price;
        var finalMinPrice = freeShippingTier.minimum * 100;
        var remainMinPrice = finalMinPrice - cartPrice;
        
        if (cartPrice > finalMinPrice) {
            rebuyCheckout.disabled = false;
        } else {
            rebuyCheckout.disabled = true;
        }
    
        if (cartPrice > finalMinPrice) {
            document.querySelector('.rebuy-cart__progress-bar-prompt').classList.add('success');
        } else {
            document.querySelector('.rebuy-cart__progress-bar-prompt').classList.remove('success');
        }  
      }
      var productBlocks = document.querySelectorAll(".rebuy-product-block");
  
      if (productBlocks.length > 0) {
          productBlocks.forEach(el => {
              if (el.querySelector("button.rebuy-button span").innerText.trim() !== "Add to Cart" && el.closest(".rebuy-cart__flyout-recommendations")) {
                el.closest(".rebuy-cart__flyout-recommendations").classList.add("value_button_show");
              }
          });
      }
  });

  window.protectMyPurchase = function() {
    const items = window.Rebuy.Cart.cart.items;
    const protectMyPurchaseItem = items.filter((item) => item.handle.includes("protect-my-purchase"));
    // console.log(protectMyPurchaseItem, protectMyPurchaseItem.length);
    if(document.querySelector(".rebuy-cart__checkout-button")) document.querySelector(".rebuy-cart__checkout-button").innerHTML = `<span>Proceed to checkout </span> | <span>$${((window.Rebuy.Cart.cart.total_price) / 100).toFixed(2)}</span>`;
  }

  window.changeRebuyCheckoutButton = function() {
    if(document.querySelector(".rebuy-cart__checkout-button")) document.querySelector(".rebuy-cart__checkout-button").disabled = !window.Rebuy.SmartCart.hasAcceptedTerms() && window.Rebuy.SmartCart.hasTermsEnabled();
  }

  document.addEventListener('rebuy:cart.change', function(event){ 
   //$('.cart-count-bubble span').text(window.Rebuy.SmartCart.itemCount());
    window.cartcount()
    window.protectMyPurchase();
    window.changeRebuyCheckoutButton();
  });

  document.addEventListener('rebuy:smartcart.show', (event) => {
    window.protectMyPurchase();
    window.changeRebuyCheckoutButton();
  });

  const checkDiv = setInterval(() => {
    const productBlocks = document.querySelectorAll(".rebuy-product-block");

    if (productBlocks.length > 0) {
      clearInterval(checkDiv); // Stop checking once found

      const cartContent = document.querySelector(".rebuy-cart .rebuy-cart__flyout-content");
      const flyoutItems = cartContent?.querySelector(".rebuy-cart__flyout-items");
      const flyoutRecs = cartContent?.querySelector(".rebuy-cart__flyout-recommendations");

      // Safety check
      if (!cartContent || !flyoutItems || !flyoutRecs) return;

      productBlocks.forEach((el) => {
        const buttonSpan = el.querySelector("button.rebuy-button span");
        const buttonText = buttonSpan?.innerText?.trim();

        if (buttonText && buttonText !== "Add to Cart") {
          el.closest(".rebuy-cart__flyout-recommendations")?.classList.add("value_button_show");
        }
      });

      // Add scroll behavior
      document.querySelectorAll(".rebuy-product-actions .rebuy-button").forEach((elm) => {
        elm.addEventListener("click", () => {
          const contentHeight =
            flyoutItems.offsetHeight + flyoutRecs.offsetHeight;

          setTimeout(() => {
            cartContent.scrollTo({
              top: contentHeight,
              behavior: "smooth",
            });
          }, 500);
        });
      });
    }
  }, 100);

  // The Rebuy SmartCart background overlay sits at z-index 2147483637 with
  // pointer-events:auto when visible, which intercepts clicks intended for
  // [data-add-to-cart] buttons and silently swallows them — the overlay closes
  // but the ATC never fires, so the theme cart never opens.
  // Fix: catch those clicks in the capture phase, peek at the element underneath
  // via a momentary pointer-events:none, and if it's an ATC button close the
  // Rebuy cart and directly trigger the theme's cart add flow.
  document.addEventListener('click', function(e) {
    if (!e.target.classList.contains('rebuy-cart__background')) return;
    const bg = e.target;
    bg.style.pointerEvents = 'none';
    const underEl = document.elementFromPoint(e.clientX, e.clientY);
    bg.style.pointerEvents = '';
    if (!underEl || !underEl.closest('[data-add-to-cart]')) return;
    e.stopImmediatePropagation();
    if (window.Rebuy && window.Rebuy.SmartCart) {
      window.Rebuy.SmartCart.hide();
    } else {
      const rebuyEl = document.querySelector('.rebuy-cart');
      if (rebuyEl) rebuyEl.classList.remove('is-visible');
    }
    const atcBtn = underEl.closest('[data-add-to-cart]');
    const form = atcBtn && atcBtn.closest('form');
    if (form && window.cart && typeof window.cart.addToCart === 'function' && !atcBtn.hasAttribute('disabled')) {
      window.cart.button = atcBtn;
      window.cart.form = form;
      window.cart.addToCart(new FormData(form));
    }
  }, true);

})();

function adjustHeight(className) {
  var elements = document.querySelectorAll('.' + className);
  elements.forEach(function (element) {
    element.style.height = 'auto';
  });

  var maxHeight = -1;
  elements.forEach(function (element) {
    var height = element.offsetHeight;
    maxHeight = height > maxHeight ? height : maxHeight;
  });

  elements.forEach(function (element) {
    element.style.height = maxHeight + 'px';
  });
}

$('.collection__filters-box.cat .collection__filters-title').each(function() {
  var expanded = $(this).next('.collection__filters-box-main').is(':visible');
  $(this).attr('aria-expanded', expanded ? 'true' : 'false');
});

$('.collection__filters-box.cat .collection__filters-title').click(function(e) {
  var $btn = $(this);
  var expanded = $btn.attr('aria-expanded') === 'true';
  $btn.attr('aria-expanded', expanded ? 'false' : 'true');
  $('.collection__filters-box.cat').toggleClass('active');
  $btn.next('.collection__filters-box-main').slideToggle();
});

// Function to handle the mutation changes
function handleMutation(mutationsList, observer) {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      // Check if the target element with the specified class is now available
      const containerWrapper = document.querySelector('.rc-container-wrapper.rc_container_wrapper');
      const customInjectionPoint = document.querySelector('.rc-custom-injection-point');

      if (containerWrapper && customInjectionPoint) {
        // Move the containerWrapper element to be a child of customInjectionPoint
        customInjectionPoint.appendChild(containerWrapper);

        // Disconnect the observer as the task is completed
        observer.disconnect();
      }
    }
  }
}

// Create a MutationObserver
const observer = new MutationObserver(handleMutation);

// Target element for the observer
const targetElement = document.body;

// Configure and start observing for childList changes
observer.observe(targetElement, { childList: true });


function minHeight(parentElement, childElement) {
  let productGrids = document.querySelectorAll(parentElement),
      gridPositions = [],
      positionGrids = [];
  if(productGrids.length == 0) return;
  
  productGrids.forEach(function(grid) {
    if(gridPositions.indexOf(grid.offsetTop) == -1) gridPositions.push(grid.offsetTop);
  });
  
  gridPositions.forEach(function (position) {
    let grids = Array.from(productGrids).filter(function (grid) {
      return (grid.offsetTop == position)
    });
    positionGrids.push(grids);
  });

  positionGrids.forEach((grids,index) => {
    let heights = []
    grids.forEach(function (grid) {
      let tmp = [];
      grid.querySelectorAll(childElement).forEach(function(element) {
        element.style.removeProperty('min-height');
       tmp.push(element.offsetHeight) 
      });
      heights.push(tmp);
    });
    if(heights.length > 0){
      let totalSelector = Math.max(...heights.map(ele => {
        return ele.length;
      }));
      grids.forEach(function (grid) {
        for (let index = 0; index < totalSelector; index++) {
          let elementHeights = Math.max(...heights.map(ele => {
            return ele[index];
          }));
          grid.querySelectorAll(childElement)[index].style.minHeight = `${elementHeights}px`;
        }
      });
    }
  });  
}

const checkDiv = setInterval(() => {
    const productBlocks = document.querySelectorAll(".related-product-slider.slick-initialized");
    if (productBlocks.length > 0) {
        minHeight('.related-product-slider .slick-slide', '.related-product-slider .slick-slide > div');
        clearInterval(checkDiv);
    }
}, 100); 

window.addEventListener('resize', function() {
  minHeight('.related-product-slider .slick-slide', '.related-product-slider .slick-slide > div');
  minHeight('.featured__collection--slider .slick-slide', '.featured__collection--slider .slick-slide > div');
});


const featuredElementInterval = setInterval(() => {
  const featuredSlider = document.querySelectorAll(".featured__collection--slider.slick-initialized");
  if (featuredSlider.length > 0) {
    minHeight('.featured__collection--slider .slick-slide', '.featured__collection--slider .slick-slide > div');
    clearInterval(featuredElementInterval);
  }
}, 100);

// Scroll-lock targets [data-collection-filters-list] (standard filters inner div),
// but cat/scent filter boxes sit above it in the DOM so scroll-lock blocks their
// touchmove events. stopPropagation prevents scroll-lock's document handler from
// calling preventDefault, letting the existing overflow-x:auto + touch-action:pan-x
// in collection.css do their job.
var filtersPanel = document.querySelector('[data-collection-filters]');
if (filtersPanel) {
  filtersPanel.addEventListener('touchmove', function(e) {
    if (e.target.closest('.collection__filters-box-main')) e.stopPropagation();
  }, { passive: true });
}

// Product description read more
function initReadMoreBtn(btn) {
  if (btn.dataset.readMoreInit) return;
  btn.dataset.readMoreInit = '1';

  var container = btn.previousElementSibling;
  if (!container || !container.hasAttribute('data-read-more-container')) return;

  if (container.scrollHeight <= container.offsetHeight) {
    btn.hidden = true;
    container.setAttribute('data-read-more-fit', '');
    return;
  }

  var labelEl = btn.querySelector('[data-read-more-label]');
  var showMore = labelEl ? labelEl.textContent.trim() : '';
  var showLess = btn.dataset.labelLess || '';
  var collapsedHeight = container.offsetHeight + 'px';
  var pendingTransition = null;
  var anchorRaf = null;

  function cancelPending() {
    if (pendingTransition) {
      container.removeEventListener('transitionend', pendingTransition);
      pendingTransition = null;
    }
    if (anchorRaf) {
      cancelAnimationFrame(anchorRaf);
      anchorRaf = null;
    }
  }

  btn.addEventListener('click', function() {
    cancelPending();
    var expanding = !container.classList.contains('is-expanded');

    if (expanding) {
      container.style.height = container.offsetHeight + 'px';
      container.classList.add('is-expanded');
      requestAnimationFrame(function() {
        container.style.height = container.scrollHeight + 'px';
      });
      pendingTransition = function(e) {
        if (e.propertyName !== 'height') return;
        cancelPending();
        container.style.height = 'auto';
        container.style.overflow = 'visible';
      };
      container.addEventListener('transitionend', pendingTransition);
    } else {
      var btnTop = btn.getBoundingClientRect().top;
      container.style.overflow = '';
      container.style.height = container.offsetHeight + 'px';
      container.classList.remove('is-expanded');
      requestAnimationFrame(function() {
        container.style.height = collapsedHeight;
      });
      anchorRaf = requestAnimationFrame(function tick() {
        var diff = btn.getBoundingClientRect().top - btnTop;
        if (diff !== 0) window.scrollBy({ top: diff, behavior: 'instant' });
        anchorRaf = requestAnimationFrame(tick);
      });
      pendingTransition = function(e) {
        if (e.propertyName !== 'height') return;
        cancelPending();
        container.style.height = '';
      };
      container.addEventListener('transitionend', pendingTransition);
    }

    btn.setAttribute('aria-expanded', String(expanding));
    if (labelEl) labelEl.textContent = expanding ? showLess : showMore;
  });
}

function initReadMoreInPanel(panel) {
  requestAnimationFrame(function() {
    panel.querySelectorAll('[data-read-more-btn]').forEach(initReadMoreBtn);
  });
}

function initReadMoreInScope(root) {
  var scope = root || document;
  scope.querySelectorAll('[data-read-more-btn]').forEach(function(btn) {
    if (!btn.closest('[data-collapsible-container]')) initReadMoreBtn(btn);
  });
  scope.querySelectorAll('[data-collapsible-container][aria-expanded="true"]').forEach(initReadMoreInPanel);
}

initReadMoreInScope();

document.querySelectorAll('[data-collapsible-trigger]').forEach(function(trigger) {
  trigger.addEventListener('click', function() {
    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (panel) initReadMoreInPanel(panel);
  });
});

document.addEventListener('shopify:section:load', function(e) { initReadMoreInScope(e.target); });
document.addEventListener('shopify:block:select', function(e) {
  var panel = e.target.closest('[data-collapsible-container]');
  if (panel) initReadMoreInPanel(panel);
});